import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner, PlayerName } from 'yankees-react-utils';
import { Col, Row } from 'react-bootstrap';
import { useOktaQuery, PitchTipping } from '../../../data';
import TippingPlayer from '../../../components/TippingPlayer';

const TippingReport = ({ isLoading, pitcherId, pitcher }) => {
    const { t: translate } = useTranslation();
    const { data, status } = useOktaQuery(['tipping', { pitcherId }], (t) => PitchTipping.getNotes(t, pitcherId));

    if (status === 'loading' || isLoading) {
        return (
            <div className="d-flex justify-content-center py-5">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div>
            {data && (
                <>
                    <Row>
                        <Col md={6}>
                            <h2>{translate('sections.opponent.player.pitch-tipping')}: { !!pitcher && <PlayerName player={pitcher} />}</h2>
                        </Col>
                        <Col md={6}>
                            <div className="flex float-end">
                                <span style={{ display: 'inline-block', padding: '5px', marginRight: '8px', backgroundColor: 'rgb(242,185,180)' }}>{translate('sections.opponent.player.tip-gone')}</span>
                                <span style={{ display: 'inline-block', padding: '5px', marginRight: '8px', backgroundColor: 'rgb(191,255,191)' }}>{translate('sections.opponent.player.confirmed')}</span>
                                <span style={{ display: 'inline-block', padding: '5px', marginRight: '8px', backgroundColor: 'rgb(255,255,170)' }}>{translate('sections.opponent.player.strong-monitor')}</span>
                                <span style={{ display: 'inline-block', padding: '5px', border: '1px solid black', backgroundColor: '#FFF' }}>{translate('sections.opponent.player.monitor')}</span>
                            </div>
                        </Col>
                    </Row>
                    <hr />
                    <TippingPlayer data={data} playerId={pitcherId} showNoneIfNoTippingNotes />
                </>
            )}
        </div>
    );
};

TippingReport.propTypes = {
    pitcherId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    isLoading: PropTypes.bool,
    pitcher: PropTypes.shape({}),
};

TippingReport.defaultProps = {
    isLoading: false,
    pitcher: null,
};

export default TippingReport;
